import { render, staticRenderFns } from "./CategoriesLanding.vue?vue&type=template&id=145f7dcf"
import script from "./CategoriesLanding.vue?vue&type=script&lang=js"
export * from "./CategoriesLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports